import type { CssGeneratorContext } from '../css-generator.model';

/**
 * The switch field takes the form field size steps of the text fields: per tier the field text size and line height,
 * and the field's vertical padding split evenly between the track (.p-togglebutton) and the pressed pill
 * (.p-togglebutton-content), so the switch is as tall as a select. Below 768px the togglebutton size tokens apply.
 */
export const styles = ({ dt }: CssGeneratorContext) => `
app-switch-field .p-togglebutton {
  @media screen and (min-width: 768px) and (max-width: 1439px) {
    font-size: ${dt('form.field.sm.font.size')};
    line-height: ${dt('form.field.sm.font.lineHeight')};
    padding-block: calc(${dt('form.field.sm.padding.y')} / 2);
  }

  @media screen and (min-width: 1440px) and (max-width: 1919px) {
    font-size: ${dt('form.field.md.font.size')};
    line-height: ${dt('form.field.md.font.lineHeight')};
    padding-block: calc(${dt('form.field.md.padding.y')} / 2);
  }

  @media screen and (min-width: 1920px) {
    font-size: ${dt('form.field.lg.font.size')};
    line-height: ${dt('form.field.lg.font.lineHeight')};
    padding-block: calc(${dt('form.field.lg.padding.y')} / 2);
  }
}

app-switch-field .p-togglebutton .p-togglebutton-content {
  @media screen and (min-width: 768px) and (max-width: 1439px) {
    padding-block: calc(${dt('form.field.sm.padding.y')} / 2);
  }

  @media screen and (min-width: 1440px) and (max-width: 1919px) {
    padding-block: calc(${dt('form.field.md.padding.y')} / 2);
  }

  @media screen and (min-width: 1920px) {
    padding-block: calc(${dt('form.field.lg.padding.y')} / 2);
  }
}
`;
